export default "__VITE_ASSET__BOnxOQ8d__"